module.exports = __webpack_public_path__ + "b6d7842e48563e7fcc1cf2534a8cad99.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/imgs/spotin_portal.svg
// module id = 215
// module chunks = 0